
export default function sketch(p) {
  let lines = [];
  const numLines = 5;
  const colors = ['#8f4a8e', '#90384a', '#af6cae', '#7e3d9b', '#5f3a73'];
  let w, h;

  p.setup = () => {
    w = p.windowWidth;
    h = p.windowHeight;
    p.createCanvas(w, h);
    p.noFill();
    lines = [];
    for (let i = 0; i < numLines; i++) {
      const y = p.random(h * 0.2, h * 0.9);
      const thickness = p.random(18, 98);
      const color = colors[Math.floor(p.random(colors.length))];
      const speed = 500.0 * p.random(-20, 20);
      lines.push({
        baseY: y,
        offset: p.random(1000),
        thickness,
        color,
        speed,
        drift: 10.0 * p.random(0.2, 0.5),
      });
    }
    if (lines[0].baseY > h * 0.3) {
      lines[0].baseY = p.random(h * 0.1, h * 0.3);
    }
  };

  p.windowResized = () => {
    w = p.windowWidth;
    h = p.windowHeight;
    p.resizeCanvas(w, h);
  };

  p.draw = () => {
    for (let x = 0; x < w; x += 20) {
      let inter = p.map(x, 0, w, 0, 1);
      let c = p.lerpColor(p.color('#ffa595'), 
            p.color('#58204b'), 
            inter);
      p.stroke(c);
      p.strokeWeight(20);
      p.line(x, 0, x, h);
    }
    lines.forEach((line) => {
      p.push();
      p.stroke(line.color);
      p.strokeWeight(line.thickness);
      p.strokeCap(p.ROUND);
      let t = p.millis() * 0.0002 + line.offset;
      let y = line.baseY + p.sin(t * line.drift) * 60;
      let x0 = -w * 0.2 + p.cos(t) * 40;
      let x1 = w * 1.2 + p.sin(t * 0.7) * 40;
      let y0 = y - (x0 - 0) * 0.5;
      let y1 = y - (x1 - 0) * 0.5;
      p.line(x0, y0, x1, y1);
      p.pop();
    });
  };
}